import { trackAmplitudeEvent } from './analytics';

declare global {
  interface Window {
    ym: (id: number, method: string, ...args: any[]) => void;
  }
}

const METRIKA_ID = 104391687;

export const trackEvent = (eventName: string, params?: Record<string, any>) => {
  trackAmplitudeEvent(eventName, params);

  if (typeof window !== 'undefined' && window.ym) {
    if (params) {
      console.log(`[Yandex Metrika] Tracking event: ${eventName}`, params);
      window.ym(METRIKA_ID, 'reachGoal', eventName, params);
    } else {
      console.log(`[Yandex Metrika] Tracking event: ${eventName}`);
      window.ym(METRIKA_ID, 'reachGoal', eventName);
    }
  } else {
    console.warn('[Yandex Metrika] Counter not loaded, event not tracked:', eventName);
  }
};

export const trackPageView = (url: string) => {
  if (typeof window !== 'undefined' && window.ym) {
    window.ym(METRIKA_ID, 'hit', url);
  }
};

/**
 * Устанавливает параметры визита в Яндекс.Метрику
 * @param params Объект с параметрами визита
 */
export const setVisitParams = (params: Record<string, string | number>) => {
  if (typeof window !== 'undefined' && window.ym) {
    console.log('[Yandex Metrika] Setting visit params:', params);
    window.ym(METRIKA_ID, 'params', params);
  } else {
    console.warn('[Yandex Metrika] Counter not loaded, visit params not set');
  }
};
